import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import Header from './Components/Header/Header';
import Banner from './Components/Banner/Banner';
import About from './Components/About/About';
import Footer from './Components/Footer/Footer';
import Projects from './Components/Projects/Projects';
import Contact from './Components/Projects/Contact/Contact';
import Blogs from './Components/Blogs/Blogs';
import ProjectModal from './Components/ProjectModal/ProjectModal';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <div className="App">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Aulad Hossen</title>
        <link rel="canonical" href="http://mysite.com/example" />
        <meta name="description" content="Portfolio" />
      </Helmet>
      <Header></Header>
      <Banner></Banner>
      <About></About>
      <Projects></Projects>
      <Blogs></Blogs>
      <Contact></Contact>
      <ProjectModal></ProjectModal>
      <Footer></Footer>
    </div>
  );
}

export default App;
